import axios, { InternalAxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

// Configurer Axios
const axiosInstance = axios.create({
    baseURL: API_URL + '/api',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Instance spécifique pour l'API DPE avec timeout étendu (5 minutes)
const axiosInstanceDPE = axios.create({
    baseURL: API_URL + '/api',
    timeout: 300000, // 5 minutes
    headers: {
        'Content-Type': 'application/json',
    },
});

// Ajouter un intercepteur pour injecter le token dans chaque requête
axiosInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        // Récupérer le token depuis sessionStorage
        const sessionData = sessionStorage.getItem('hectorSession');
        let token = null;
        
        if (sessionData) {
            try {
                const parsedData = JSON.parse(sessionData);
                token = parsedData.accessToken;
            } catch (error) {
                console.error('Erreur lors de la récupération du token:', error);
            }
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error: AxiosError) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
        console.error('Erreur API:', error);
        return Promise.reject(error);
    }
);

// Ajouter les mêmes intercepteurs à l'instance DPE
axiosInstanceDPE.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        // Récupérer le token depuis sessionStorage
        const sessionData = sessionStorage.getItem('hectorSession');
        let token = null;
        
        if (sessionData) {
            try {
                const parsedData = JSON.parse(sessionData);
                token = parsedData.accessToken;
            } catch (error) {
                console.error('Erreur lors de la récupération du token:', error);
            }
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error: AxiosError) => {
        return Promise.reject(error);
    }
);

axiosInstanceDPE.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
        console.error('Erreur API DPE:', error);
        return Promise.reject(error);
    }
);

export default axiosInstance;
export { axiosInstanceDPE };
